/* unplugin-vue-components disabled */import { render } from "./showXRated.vue?vue&type=template&id=c094c024&scoped=true"
import script from "./showXRated.vue?vue&type=script&lang=js"
export * from "./showXRated.vue?vue&type=script&lang=js"

import "./showXRated.vue?vue&type=style&index=0&id=c094c024&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c094c024"]])

export default __exports__